import FadingGallery from 'lib/fading-gallery';
import VideoPlayer from 'lib/video-player';
import TiledFadingGallery from 'lib/tiled-fading-gallery';

export default function init_misc() {
    init_fading_galleries();
    init_tiled_fading_galleries();
    init_video_players();
}

function init_fading_galleries() {
    window.addEventListener('load', function () {
        const elements = Array.from(document.querySelectorAll('.fading-gallery'));

        elements.forEach(element => FadingGallery(element));
    });
}

function init_tiled_fading_galleries() {
    window.addEventListener('load', function () {
        const elements = Array.from(document.querySelectorAll('.gallery-grid'));

        elements.forEach(element => TiledFadingGallery(element, {
            imageSelector: '.gallery-link',
            tileSelector: '.gallery-tile'
        }));
    });
}

function init_video_players() {
    window.addEventListener('load', function () {
        const elements = Array.from(document.querySelectorAll('.video-player'));

        elements.forEach(element => VideoPlayer(element));
    });
}